import React from "react";
import { Button, Col, FormGroup, Label } from "reactstrap";

/**
 * Aligns an action button with labeled filter inputs in the same row.
 */
export function AccountingFilterApplyButton({
  onClick,
  disabled = false,
  loading = false,
  label = "Apply",
  size,
  color = "primary",
  colProps = { md: "auto" },
  className,
}) {
  return (
    <Col {...colProps}>
      <FormGroup className="mb-0">
        <Label className="invisible user-select-none" aria-hidden="true">
          &nbsp;
        </Label>
        <Button
          color={color}
          size={size}
          className={className}
          onClick={onClick}
          disabled={disabled || loading}
        >
          {label}
        </Button>
      </FormGroup>
    </Col>
  );
}

/**
 * Same alignment fix for flex (non-Row) filter toolbars.
 */
export function AccountingFilterApplyButtonInline({
  onClick,
  disabled = false,
  loading = false,
  label = "Apply",
  size,
  color = "primary",
  className,
}) {
  return (
    <FormGroup className="mb-0">
      <Label className="invisible user-select-none" aria-hidden="true">
        &nbsp;
      </Label>
      <Button
        color={color}
        size={size}
        className={className}
        onClick={onClick}
        disabled={disabled || loading}
      >
        {label}
      </Button>
    </FormGroup>
  );
}

export default AccountingFilterApplyButton;
